import React, { Component } from 'react'
import { SecureContainer, FormInput } from '../components'
import { requestResetForgotInstructions } from '../api'

class Forgot extends Component {
    state = {
        email: "",
        success: false,
        error: false,
        error_message: undefined
    }
    onSubmit = (event) => {
        event.preventDefault()
        this.setState({ success: false, error: false, error_message: undefined })
        requestResetForgotInstructions(this.state.email).then((data) => {
            this.setState({ success: true })
        }).catch(err => {
            let error_message = "You need to pass a valid email"
            if (err.message.indexOf("USER_NOT_FOUND") != -1) {
                error_message = "This email was not found on our database. Please try other one."
            }
            this.setState({ error: true, error_message })
        })
    }
    render() {
        return (
            <SecureContainer title="Forgot Password?">
                {(!this.state.success) && (
                    <form onSubmit={this.onSubmit}>
                        <p>Enter the email address you used when you joined and we’ll send you instructions to reset your password.</p>
                        <p>For security reasons, we do NOT store your password. So rest assured that we will never send your password via email.</p>

                        {this.state.error && (
                            <div>
                                <span style={{ color: 'red' }}>{this.state.error_message}</span>
                            </div>
                        )}
                        <FormInput
                            onChange={(text) => {
                                this.setState({ email: text })
                            }}
                            type="email"
                            value={this.state.email}
                            required
                            placeholder="Email Address" />

                        <button type="submit" className="btn btn-info btn-block" style={{ marginTop: '24px' }}>Send Reset Instructions</button>
                    </form>
                )}
                {this.state.success && (
                    <div>
                        <p>If everything is correct, we will send you an email with all instructions. Stay tuned!</p>
                        <a href="/" className="btn btn-info btn-block" style={{ marginTop: '24px' }}>Back to Login</a>
                    </div>
                )}
            </SecureContainer>
        )
    }
}

export default Forgot;


// WEBPACK FOOTER //
// ./src/routers/Forgot.js